import React from 'react';
import { useEffect, useRef } from 'react'
import MarkdownResponseDisplay from '../markdown/MarkdownResponseDisplay';

import "./scrolltextanswer.css"

export const ScrollTextAnswer = ({text}) => {


  const textAreaRef = useRef(null);

  useEffect(() => {
    
    if (textAreaRef.current) {
      textAreaRef.current.style.height = 'auto';
      textAreaRef.current.style.height = `${textAreaRef.current.scrollHeight}px`;
    }
    
  }, [text, textAreaRef]);
  
  return (
    <div>
      <div className= 'answerStyle' >
      <MarkdownResponseDisplay text={text} /> 
      </div>
    </div>
  );
  

 
};

ScrollTextAnswer.defaultProps = {
  
}
